module.exports = __webpack_public_path__ + "static/media/side-effects-lead-in-image.17af17b7.png";